import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { AccountChildrenButtonAccountFragmentDoc } from './AccountChildrenButtonAccount.generated'
import { AccountInfoButtonAccountFragmentDoc } from './AccountInfoButtonAccount.generated'
import { AccountMoreOptionsMenuAccountFragmentDoc } from './AccountMoreOptionsMenuAccount.generated'
import * as Types from './purchasePlus_graphql'

export const AccountCodesTableViewAccountFragmentDoc = gql`
  fragment AccountCodesTableViewAccount on Account {
    id
    name
    code
    description
    parent {
      id
      name
      code
    }
    ...AccountChildrenButtonAccount
    ...AccountInfoButtonAccount
    ...AccountMoreOptionsMenuAccount
  }
  ${AccountChildrenButtonAccountFragmentDoc}
  ${AccountInfoButtonAccountFragmentDoc}
  ${AccountMoreOptionsMenuAccountFragmentDoc}
` as unknown as DocumentNode<Types.AccountCodesTableViewAccountFragment, unknown>
